module.exports = __webpack_public_path__ + "avatar9.svg?53501cf44aac8db07b51ce368a083014";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar9.svg
// module id = 145
// module chunks = 2